<template>
  <div class="jd-section">
    <div class="jd-section-header">
      <h3>スカウトに添付する求人</h3>
    </div>
    <div v-if="applicantJd" class="jd-section-content">
      {{ applicantJd.jd_info.job_title }}
    </div>
    <div v-else class="jd-section-empty">
      添付求人なし
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ScoutJobSection',
  // props: {
  //   applicantJd: {
  //     type: Object,
  //     default: () => null
  //   }
  // },
  computed: {
    ...mapGetters({
      applicantJd: 'getApplicantJd',
    }),
  },
};
</script>

<style scoped>

h3 {
  font-size: 16px;
  font-weight: bold;
}

.jd-section {
  padding: 10px;
  background: white;
  border-radius: 10px;
}

.jd-section-content {
  font-size: 15px;
  color: #036ac9;
}

.jd-section-empty {
  font-size: 16px;
  color: #000000;
}
</style>
